var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"donation-form-section mt-3"},[_c('h5',{staticClass:"donation-form-section-title",style:({ 'background-color': _vm.orgaColor })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"donation-form-content"},[_vm._t("form")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }